import { MainLayout } from '../layouts/MainLayout';

export default function BillingPage() {
  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-white mb-6">Billing</h1>
          <div className="bg-slate-800/30 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6">
            <p className="text-slate-300">Billing information and subscription management will be available here.</p>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
